import apiClient from "services/apiClient";

async function editMarkerStyle(id: any, data: any) {
  const url = `/admin/marker-style/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editMarkerStyle;
